import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { TopdownAdjustmentComponent } from './topdown-adjustment.component'; 

const routes: Routes = [
  {
    path: "",
    component: TopdownAdjustmentComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class TopdownAdjustmentRoutingModule {}
